export const costs = [
  'Prepari ogni lezione di meteorologia da zero, cercando materiale sparso su internet',
  'Spiegare fronti, pressione e nubi senza immagini chiare è difficile',
  'Non hai attività, esperimenti e verifiche pronte da usare in classe',
  'Ti manca tempo per programmare unità didattiche complete e coerenti',
];
